import classNames from 'classnames';
import { FC } from 'react';

export interface DividerProps {
  className?: string;
  backgroundImage?: string;
}

const Divider: FC<DividerProps> = ({ className, backgroundImage }) => {
  return (
    <div
      className={classNames(
        'w-screen -translate-x-1/2 left-1/2 relative mb-8 md:mt-8 md:mb-20 h-3 md:h-5 bg-cover bg-no-repeat overflow-x-visible',
        className,
      )}
      style={{
        backgroundImage:
          backgroundImage || `url(/assets/images/multi-color-divider.png)`,
      }}
    />
  );
};

export default Divider;
